<template>
  <div class="legal-form">
    <el-form
      ref="ruleForm"
      label-width="150px"
      class="demo-ruleForm"
      :model="ruleForm"
      :rules="rules"
      inline-message
      size="mini"
    >
      <!-- 证件类型 -->
      <el-form-item label="证件类型：" prop="legalIdCardType" class="wd200">
        <el-select v-model="ruleForm.legalIdCardType" :disabled="status === 1" placeholder="请选择">
          <el-option
            v-for="item in paperworkOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <div v-show="reasons.legalIdCardType" class="reason">驳回原因：{{ reasons.legalIdCardType }}</div>
      </el-form-item>

      <!-- 证件号码 -->
      <el-form-item label="证件号码：" prop="legalIdCardCode" class="wd200">
        <el-input v-model="ruleForm.legalIdCardCode" :disabled="status === 1" placeholder="请输入您的证件号"></el-input>
        <div v-show="reasons.legalIdCardCode" class="reason">驳回原因：{{ reasons.legalIdCardCode }}</div>
      </el-form-item>

      <!-- 证件姓名 -->
      <el-form-item label="证件姓名：" prop="legalIdCardName" class="wd200">
        <el-input
          v-model="ruleForm.legalIdCardName"
          :disabled="status === 1"
          placeholder="请输入您的证件姓名"
          @input="_limitLen(undefined, undefined, key = 'legalIdCardName', len = 30)"
        ></el-input>
        <div v-show="reasons.legalIdCardName" class="reason">驳回原因：{{ reasons.legalIdCardName }}</div>
      </el-form-item>

      <el-form-item>
        <div class="download-tips">
          请确保填写的<span class="highlight">证件姓名</span>与您的<span class="highlight">身份证</span>完全一致，否则有<span class="highlight">认证风险</span>。
        </div>
      </el-form-item>

      <!-- 证件到期时间 -->
      <el-form-item class="form2item" label="证件到期时间：" required>
        <el-col :span="8">
          <el-form-item prop="legalIdCardExpireDateStart">
            <el-date-picker
              v-model="ruleForm.legalIdCardExpireDateStart"
              :disabled="status === 1 || ruleForm.legalIdCardIsLongTermEffective"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              :picker-options="{disabledDate(time) {
                return time.getTime() > Date.now()
              }}"
            ></el-date-picker>
            <div v-show="reasons.legalIdCardExpireDateStart" class="reason">驳回原因：{{ reasons.legalIdCardExpireDateStart }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="textAlign: center; margin: 0 10px;">至</el-col>
        <el-col :span="8">
          <el-form-item prop="legalIdCardExpireDateEnd">
            <el-date-picker
              v-model="ruleForm.legalIdCardExpireDateEnd"
              :disabled="status === 1 || ruleForm.legalIdCardIsLongTermEffective"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择时间"
              :picker-options="{disabledDate(time) {
                return time.getTime() < Date.now()
              }}"
            ></el-date-picker>
            <div v-show="reasons.legalIdCardExpireDateEnd" class="reason">驳回原因：{{ reasons.legalIdCardExpireDateEnd }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="marginLeft: 10px">
          <el-checkbox v-model="ruleForm.legalIdCardIsLongTermEffective" :disabled="status === 1">长期有效</el-checkbox>
        </el-col>
        <div v-show="reasons.legalIdCardIsLongTermEffective" class="reason" style="margin-top:28px">驳回原因：{{ reasons.legalIdCardIsLongTermEffective }}</div>
      </el-form-item>
      <el-form-item label="请上传身份证照片：" prop="mobile">
        <span>图片尺寸<span class="highlight">800px*800px</span>以上，大小不超过<span class="highlight">1M</span>，格式<span class="highlight">png/jpg/jpeg</span>，请保证身份证信息清晰可见。</span>
      </el-form-item>

      <!-- 身份证正面 -->
      <el-form-item label="身份证正面：" prop="legalIdCardFrontObjectId">
        <el-upload
          v-model="ruleForm.legalIdCardFrontObjectId"
          class="avatar-uploader"
          :class="[ruleForm.legalIdCardFrontObjectId ? 'active' : 'inactive']"
          action=""
          accept="image/*"
          :disabled="status === 1"
          :show-file-list="false"
          :http-request="ctx => imageUpload(ctx, 'ruleForm', 'ruleForm','legalIdCardFrontObjectId')"
          :before-upload="beforeImageUpload()"
        >
          <div v-if="status !== 1 && ruleForm.legalIdCardFrontObjectId" class="btn-close" @click.stop="removeImage(ruleForm, 'legalIdCardFrontObjectId')">
            <img src="@/assets/img/icon-close.png">
          </div>
          <img v-if="ruleForm.legalIdCardFrontObjectId" :src="encodeImgURl('ruleForm', 'legalIdCardFrontObjectId')" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div v-show="reasons.legalIdCardFrontObjectId" class="reason">驳回原因：{{ reasons.legalIdCardFrontObjectId }}</div>
      </el-form-item>

      <!-- 身份证反面 -->
      <el-form-item label="身份证反面：" prop="legalIdCardBackObjectId">
        <el-upload
          v-model="ruleForm.legalIdCardBackObjectId"
          class="avatar-uploader"
          :class="[ruleForm.legalIdCardBackObjectId ? 'active' : 'inactive']"
          action=""
          accept="image/*"
          :disabled="status === 1"
          :show-file-list="false"
          :http-request="ctx => imageUpload(ctx, 'ruleForm', 'ruleForm','legalIdCardBackObjectId')"
          :before-upload="beforeImageUpload()"
        >
          <div v-if="status !== 1 && ruleForm.legalIdCardBackObjectId" class="btn-close" @click.stop="removeImage(ruleForm, 'legalIdCardBackObjectId')">
            <img src="@/assets/img/icon-close.png">
          </div>
          <img v-if="ruleForm.legalIdCardBackObjectId" :src="encodeImgURl('ruleForm', 'legalIdCardBackObjectId')" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div v-show="reasons.legalIdCardBackObjectId" class="reason">驳回原因：{{ reasons.legalIdCardBackObjectId }}</div>
      </el-form-item>

      <!-- 底部按钮 -->
      <el-form-item class="form-footer">
        <el-button v-if="status === 0" class="mi-primary-plain" @click="lastEachStep()">上一步</el-button>
        <el-button
          v-if="status === 0"
          class="mi-primary"
          :disabled="saveBtnDisabled"
          @click="submitForm('ruleForm')"
        >
          保存并下一步
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import { isID, isHKCard, isMacaoCard, isTWCard, isPassPortCard } from '@/common/reg'
import { processMixin } from '@/common/mixin'
import { validateLegal } from '@/api/merchant'
import { shallowMerge } from '@/utils'
import legalRules from './rules/legal'

export default {
  mixins: [processMixin],
  props: {
    // 表单状态，0:填写阶段 1:禁止修改 2:可以修改
    status: {
      type: Number,
      default: 0
    }
  },
  data() {
    const rules = {
      legalIdCardType: legalRules.legalIdCardType(),
      legalIdCardCode: legalRules.legalIdCardCode(this.idReg),
      legalIdCardName: legalRules.legalIdCardName(),
      legalIdCardFrontObjectId: legalRules.legalIdCardFrontObjectId(),
      legalIdCardBackObjectId: legalRules.legalIdCardBackObjectId(),
      legalIdCardExpireDateStart: legalRules.legalIdCardExpireDateStart(),
      legalIdCardExpireDateEnd: legalRules.legalIdCardExpireDateEnd()
    }

    return {
      rules,
      saveBtnDisabled: false,
      paperworkOptions: [
        { value: '1', label: '居住身份证' },
        { value: '2', label: '香港身份证' },
        { value: '3', label: '澳门身份证' },
        { value: '4', label: '台湾身份证' },
        { value: '5', label: '外籍护照' }
      ],
      protocolOptions: [
        '《有品平台商家服务协议》',
        '《有品商家保证金协议》',
        '《有品商家违规处罚条例》'
      ],
      ruleForm: {
        legalIdCardType: '',
        legalIdCardCode: '',
        legalIdCardName: '',
        legalIdCardExpireDateStart: '',
        legalIdCardExpireDateEnd: '',
        legalIdCardIsLongTermEffective: false,
        legalIdCardFrontObjectId: '',
        legalIdCardBackObjectId: ''
      },
      reasons: {
        legalIdCardType: null,
        legalIdCardCode: null,
        legalIdCardName: null,
        legalIdCardExpireDateStart: null,
        legalIdCardExpireDateEnd: null,
        legalIdCardIsLongTermEffective: null,
        legalIdCardFrontObjectId: null,
        legalIdCardBackObjectId: null
      }
    }
  },
  computed: {
    ...mapState({
      merchantData: state => state.merchantData,
      isOverseas: state => state.isOverseas
    })
  },
  watch: {
    'ruleForm.legalIdCardType'(newVal, oldVal) {
      if (newVal && newVal !== oldVal && this.ruleForm.legalIdCardCode) {
        this.$refs.ruleForm.validateField(['legalIdCardCode'])
      }
    },
    'ruleForm.legalIdCardIsLongTermEffective'(newVal) {
      if (newVal) {
        this.rules.legalIdCardExpireDateStart = { required: false }
        this.rules.legalIdCardExpireDateEnd = { required: false }
        this.$refs.ruleForm.clearValidate([ 'legalIdCardExpireDateStart', 'legalIdCardExpireDateEnd' ])
      } else {
        this.rules.legalIdCardExpireDateStart = [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }]
        this.rules.legalIdCardExpireDateEnd = [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }]
      }
    }
  },

  mounted() {
    if (this.merchantData && this.merchantData.legal) {
      const data = this.merchantData.legal
      this.ruleForm.legalIdCardIsLongTermEffective =
        data.legalIdCardIsLongTermEffective === 'Y' ||
        data.legalIdCardIsLongTermEffective === true
      if (data.legalIdCardCode) {
        this.ruleForm.protocols = this.protocolOptions
      }
      for (let key in data) {
        for (let key1 in this.ruleForm) {
          if (key !== 'legalIdCardIsLongTermEffective' && key === key1) {
            this.ruleForm[key] = data[key]
          }
        }
      }
      for (let key in this.reasons) {
        const key1 = key + 'Review'
        if (data.reviewDetail && key1 in data.reviewDetail && data.reviewDetail[key1].reject) {
          this.reasons[key] = data.reviewDetail[key1].remark
        }
      }
    }
    this.$emit('updateReasonCount', 'legalForm', Object.values(this.reasons).reduce((acc, cur) => acc + (cur ? 1 : 0), 0))
  },

  methods: {
    ...mapMutations({
      setContactIndex: 'SET_CONTACT_INDEX',
      setStepIndex: 'SET_STEP_INDEX',
      setMerchantData: 'SET_MERCHANT_DATA'
    }),
    idReg() {
      switch (this.ruleForm.legalIdCardType) {
        case '1': return isID
        case '2': return isHKCard
        case '3': return isMacaoCard
        case '4': return isTWCard
        case '5': return isPassPortCard
        default: return isID
      }
    },
    handleIdCardFrontSuccess(res, file) {
      if (!res.code) this.ruleForm.legalIdCardFrontObjectId = res.data.objectId
      else this.$message.error('上传失败，请重试')
      this.$refs.ruleForm.validateField(['legalIdCardFrontObjectId'])
    },
    handleIdCardBacktSuccess(res, file) {
      if (!res.code) this.ruleForm.legalIdCardBackObjectId = res.data.objectId
      else this.$message.error('上传失败，请重试')
      this.$refs.ruleForm.validateField(['legalIdCardBackObjectId'])
    },
    changeProtocols() {
      if (this.ruleForm.protocols.length === 3) this.$refs.ruleForm.validateField(['protocols'])
      else this.$refs.ruleForm.clearValidate(['protocols'])
    },
    submitForm(formName, jump = true) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            if (this.ruleForm.legalIdCardIsLongTermEffective) {
              this.ruleForm.legalIdCardExpireDateStart = ''
              this.ruleForm.legalIdCardExpireDateEnd = ''
            }
            let params = {
              ...this.ruleForm,
              legalIdCardIsLongTermEffective: this.ruleForm
                .legalIdCardIsLongTermEffective ? 'Y' : 'N'
            }
            params.protocols = null
            delete params.protocols

            // 海淘商家参数调整
            if (this.isOverseas) {
              params['companyProvince'] = '0'
              params['companyCity'] = '0'
              params['companyDistrict]'] = '0'
              params['companyTaxpayerType'] = '0'
              params['companyTaxpayerTypeCode'] = '0'
            }

            this.saveBtnDisabled = true
            const info = await validateLegal(params)
            this.saveBtnDisabled = false

            if (!info.code) {
              this.setMerchantData(shallowMerge({ legal: params }, this.merchantData))
              if (jump) {
                this.setStepIndex(1)
              }
              resolve()
            } else {
              this.$message.error(`${info.msg}` || '网络出错，请重试')
              reject()
            }
          } else {
            reject()
            return false
          }
        })
      })
    },
    lastEachStep() {
      this.setMerchantData(shallowMerge({ legal: this.ruleForm }, this.merchantData))
      this.setContactIndex(1)
    },
    /**
     * @name removeImage
     * @description 删除图片按钮
     */
    removeImage(ruleForm, key) {
      ruleForm[key] = null
    }
  }
}
</script>
<style lang="less">
.legal-form {
  .demo-ruleForm {
    .wd200 {
      .el-input {
        width: 450px;
      }
    }
  }
  .form2item {
    .el-col-8 {
      width: 200px;
      .el-date-editor {
        width: 200px !important;
      }
    }
  }

  .el-checkbox-group {
    .el-checkbox__label {
      font-size: 0 !important;
      padding-left: 0;
    }
    a {
      font-size: 12px;
    }
  }

  .el-checkbox-group {
    .el-checkbox {
      margin-left: 0;
    }
  }

  .el-form {
    .download-text {
      text-decoration: none;
    }
  }

  .reason {
    font-size: 13px;
    line-height: 16px;
    color: #E00C0C;
    padding: 10px 0 0 10px;
  }
}
</style>
